const limitString = (string: string, limit: number) => {
  if (!string || !string.length) return '';

  if (string.length > limit) {
    return `${string.slice(0, limit)}...`;
  }

  return string;
};

export default limitString;
